const { LIST_PER_PAGE } = process.env;



// eslint-disable-next-line no-restricted-globals
export const PerPage = LIST_PER_PAGE || 10;

export const Role = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  RESELLER: 3,
  SUPERWISER: 4,
  TEAMLEAD: 5,
  OTHER: 6,
}

export const defaultRole = {
  ADMIN: 2,
  TEAMLEAD: 5,
  AGENT: 6
}

export const superAdminAccess = [Role.SUPER_ADMIN, Role.RESELLER]
export const userAccess = [Role.SUPER_ADMIN, Role.RESELLER, Role.ADMIN];

export const agentAccess = [Role.SUPER_ADMIN, Role.RESELLER, Role.ADMIN, Role.TEAMLEAD];
export const otherUser = [Role.OTHER];
export const otherAccess = [Role.OTHER,Role.TEAMLEAD];
export const teamleaderAccess = [Role.TEAMLEAD];
export const superWiserAccess = [Role.SUPERWISER];

// userAccess.includes(currentUser.role) &&


// WEBPACK FOOTER //
// src/helpers/system-config.js